import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class UserService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  requestPasswordReset(user) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/actions/forgot-password",
          {
            email: user.email,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  checkRecoveryToken(token) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/actions/checkRecoveryToken",
          {
            token: token,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  setNewPassword(data) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/actions/change-password",
          {
            password: data.password,
            token: data.token,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          console.log("New password was set!");
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getUser() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(this.env.managirUrl + "/users", {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.UserResponse.users[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  updateUser(user) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(
          this.env.managirUrl + "/users/" + user._id,
          {
            user,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  changePassword(userId, data) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/users/changePassword/" + userId,
          {
            oldPassword: data.oldPassword,
            newPassword: data.newPassword,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/user/user.service.ts